import React, { useMemo, useState } from "react";

import { ProjectItem, ProjectItemProps } from "../project-item";
import { Container } from "react-bootstrap";

export interface ProjectItemsGroupProps {
  imagePositionStrategy?: "firstLeft" | "firstRight";
  items?: ProjectItemProps[];
}

export function ProjectItemsGroup(props: ProjectItemsGroupProps) {
  const { imagePositionStrategy = "firstLeft" } = props;
  const items = useMemo<ProjectItemProps[]>(() => {
    const projectItems = props.items || [];
    return projectItems.map((item, index) => {
      if (index % 2 === 0) {
        return {
          ...item,
          imagePosition:
            imagePositionStrategy === "firstLeft" ? "left" : "right"
        };
      } else {
        return {
          ...item,
          imagePosition:
            imagePositionStrategy === "firstLeft" ? "right" : "left"
        };
      }
    });
  }, [props.items]);

  return (
    <Container>
      {" "}
      {items.map((item, index) => (
        <ProjectItem
          index={index}
          key={index}
          title={item.title}
          description={item.description}
          image={item.image}
          link={item.link}
          imagePosition={item.imagePosition}
        />
      ))}
    </Container>
  );
}
